export const apiMethods = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};

export const ApiEnvironment = {
  LOCAL: "https://localhost:8080",
  DEV: "https://172.30.116.2:8080/",
  QA: "https://172.30.116.2:3000/",
  PRODUCTION: "",
};

export const apiEndpoints = {
  LOGIN: "login",
  LOGOUT: "logout",
  USER: "user",
  USERS: "users",
  CASES: "cases",
  CASEDETAILS: "casedetails",
  NOTES: "notes",
  VITALS: "vitals",
  ADDVITAL: "Vital",
  NOTE: "note",
  MEDICATIONS: "medications",
  REASONS: "reasons",
  FREQUENCY: "frequency",
  TELEMEDICATIONS: "telemedications",
  INVESTIGATIONS: "investigations",
  INVESTIGATION: "investigation",
  NURSEINITIATED: "nurseInitiated",
  TEMPLATE_NOTE: "templateNote",
  TEMPLATE_NOTES: "templateNotes",
  MASTERTEMPLATELIST: "masterTemplateList",
  ALLTEMPLATESLIST: "templates",
  TEMPLATE: "template",
  UPDATE_TEMPLATE: "updateTemplate",
  CREATE_TEMPLATE: "createTemplate",
  MASTERTEMPLATEINVESTIGATIONS: "templateInvestigations",
  TEMPLATEINVESTIGATION: "templateInvestigation",
  TEMPLATEMEDICATIONS: "templateMedications",
  TEMPLATE_MEDICATION: "templateMedication",
  TEMPLATE_VITALS: "templateVitals",
  TEMPLATE_VITAL: "templateVital",
  COHORT: "Cohorts",
  ASSIGNTEMPLATE: "assignTemplate",
  ASSIGNTEMPLATE_STATUS: "Status",
  TEMPLATE_FLUID_ORDER: "fluidOrder",
  TEMPLATE_FLUID_ORDERS: "fluidOrders",
  BULK_UPLOAD: "bulkUpload",
  NURSING_FLUID_ORDER: "prescribedFluidorders",
  NURSING_ADMINSTER_FLUIDORDER: "administerFluidorder",
  CASE_REPORT: "case",
  MASTER_ARCHIVE: "Archive",
  DYNAMIC_PAGES: "dynamicPagesData",
  SETTINGS: "settings",
  CLONE_TEMPLATE: "cloneTemplate",
  MEDICATION_HISTORY: "history",
};

export const notificationActions = {
  DELETED: "Deleted",
  UPDATED: "Updated",
  UPLOADED: "Uploaded",
  ADDED: "Added",
  FILE: "File",
  PRESCRIPTION: "Prescription",
  VITALS: "Vitals",
};

export const notificationMessages = {
  FILE: "File has been Successfully",
  DELETE_RECORD_CONFIRMATION: "Are you sure you want to delete this",
  DELETE_MULTIPLE_RECORD_CONFIRMATION: "Are you sure you want to delete these",
};

export enum EErrorMessages {
  EmptyDate = "Please select an Effective Date before proceeding",
  EmptyFile = "Please upload your student list file before assigning to students.",
  InvalidFormat = "Invalid file format. Please upload a CSV file.",
  InvalidTemplate = "Invalid template format. Please upload correct template.",
  ExceedsSize = "File size exceeds the 10 MB limit. Please upload a smaller CSV file.",
  InvalidandExceedsSize = "Invalid file. Please ensure the file is a CSV and does not exceed the 10 MB size limit.",
  ExceedLimit = "The student list cannot exceed 50 students. Please upload a smaller file.",
  NoDataFound = "For a successful upload, at least one row of records must be present in the template.",
  FileSizeExceededMessage = "File size exceeds the allowed limit. Please upload an image smaller than 2 MB.",
  ErrorInvalidFileFormat = "Invalid File format. Please upload a JPG or PNG image.",
}

export const EEmptyFile = (type = "") => {
  return `Please upload your ${type} list file before assigning Roles and Permission.`;
};
